import { renderAuthenticatedApp } from './authenticatedApp';
import { renderNonAuthenticatedApp } from './nonAuthenticatedApp';

const PROD_COOKIE_CHECKER_URL = 'https://cw-thirdpartycookiechecker.auth.connectwise.com';
const NON_PROD_COOKIE_CHECKER_URL = 'https://cw-thirdpartycookiechecker.sts.connectwisedev.com';

const EVENTS_LIST = {
    SUPPORTED: 'MM:3PCsupported',
    UN_SUPPORTED: 'MM:3PCunsupported',
};

const inIframe = window.self !== window.top;
const STORAGE_KEY = 'cw:thirdPartyCookieSupproted';
const thirdPartyCookieSupportStatus = localStorage.getItem(STORAGE_KEY);

const getCookieCheckerUrl = () => {
    const CURRENT_URL = window.location.origin;
    if (CURRENT_URL.includes('.myconnectwise.net') || CURRENT_URL.includes('.connectwise.com')) {
        return `${PROD_COOKIE_CHECKER_URL}/cw-thirdparty-cookies-checker/start.html`;
    }
    return `${NON_PROD_COOKIE_CHECKER_URL}/cw-thirdparty-cookies-checker/start.html`;
};

const messageHandler = function (evt) {
    if (!evt.origin.includes('https://cw-thirdpartycookiechecker')) {
        return;
    }
    // UM page reload happens for OIDC authentication flow
    // we can directly read from localStorage instead of checking again
    localStorage.setItem(STORAGE_KEY, evt.data);

    if (evt.data === EVENTS_LIST.SUPPORTED) {
        renderAuthenticatedApp();
    } else {
        renderNonAuthenticatedApp();
    }
    // Remove the iframe after the check is done
    document.removeEventListener('message', messageHandler);
    const iframe = document.getElementById('third-party-cookie-checker-iframe');
    iframe?.remove();
};

if (inIframe) {
    if (thirdPartyCookieSupportStatus === EVENTS_LIST.SUPPORTED) {
        renderAuthenticatedApp();
        localStorage.removeItem(STORAGE_KEY);
    } else {
        window.addEventListener('message', messageHandler, false);
        document
            .querySelector('body')
            .insertAdjacentHTML(
                'beforeend',
                `<iframe id="third-party-cookie-checker-iframe" src="${getCookieCheckerUrl()}" style="display:none;"></iframe>`
            );
    }
} else {
    renderAuthenticatedApp();
}
